// extracted by mini-css-extract-plugin
module.exports = {"MobilePageTitle":"MobilePageTitle_MobilePageTitle__2Ch1K"};